module.exports = __webpack_public_path__ + "img/icon-station-user-active.e721251a.svg";